export default __webpack_public_path__ + "static/media/manage-modifier.0822efa9.svg";